import axios from 'axios';
import config from '../config';
import { getUserToken } from '../utils/helper';

export const GET_ANALYSIS = 'GET_ANALYSIS';
export const GET_ANALYSIS_SUCCESS = 'GET_ANALYSIS_SUCCESS';
export const GET_ANALYSIS_FAIL = 'GET_ANALYSIS_FAIL';
export const GET_ANALYSIS_RESET = 'GET_ANALYSIS_RESET';

export const getAnalysis = (params) => {
	return {
		type: GET_ANALYSIS,
		params,
	};
};

export const getAnalysisSuccess = (response) => {
	return {
		type: GET_ANALYSIS_SUCCESS,
		response,
	};
};

export const getAnalysisFail = (response) => {
	return {
		type: GET_ANALYSIS_FAIL,
		response,
	};
};

export const getAnalysisReset = () => {
	return {
		type: GET_ANALYSIS_RESET,
	};
};

export const getAnalysisApi = (data) => {
	return (dispatch) => {
		dispatch(getAnalysis());
		axios
			.get(`${config.api.base_url}/coverage/get-analysis`, {
				params: data,
				headers: {
					Authorization: 'Bearer ' + getUserToken(),
				},
			})
			.then((response) => {
				const getAnalysisData = response.data;
				dispatch(getAnalysisSuccess(getAnalysisData));
			})
			.catch((error) => {
				const errorMsg = error.message;
				dispatch(getAnalysisFail(errorMsg));
			});
	};
};
